module.exports = new __parcel__URL__("left-icon.9d0fb470.svg").toString();